<template>
  <div class="post-box" :class="(bookType == 1 && applicantType == 0) || alwaysLeft ? 'left' : ''" id="postCode" @click.stop="() => {}">
    <div class="code-box">
      <div class="tab-box">
        <nav class="tab-item" :class="item.id == tabVal ? 'active' : ''" v-for="item in tabList" :key="item.id"
          @click="tabChange(item.id)">{{ item.name }}</nav>
      </div>
      <!-- 省份区块 -->
      <div v-show="tabVal == 1">
        <div class="code-list" v-for="(item, key) in millList" :key="key">
          <div class="code-list-name">{{ key }}</div>
          <div class="code-list-box">
            <div class="clb-item" v-for="val in item" :key="item.id" @click="codeChange(val)">{{ val.name }}</div>
          </div>
        </div>
      </div>
      <!-- 城市区块 -->
      <div v-show="tabVal == 2">
        <div class="code-list" v-for="(item, key) in cityList" :key="key">
          <div class="code-list-name">{{ key }}</div>
          <div class="code-list-box">
            <div class="clb-item" v-for="val in item" :key="item.id" @click="codeChange(val)">{{ val.name }}</div>
          </div>
        </div>
      </div>
      <!-- 区县区块 -->
      <div v-show="tabVal == 3">
        <div class="code-list" v-for="(item, key) in countryList" :key="key">
          <div class="code-list-name">{{ key }}</div>
          <div class="code-list-box">
            <div class="clb-item" v-for="val in item" :key="item.id" @click="codeChange(val)">{{ val.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _tools from "@/components/common/tools";
import _validate from "@/framework/common/qds_validate";
export default {
  props: ['millList', 'millState', 'bookType', 'applicantType', 'alwaysLeft'],
  data() {
    return {
      tabList: [
        { id: 1, name: '省份' },
        { id: 2, name: '城市' },
        { id: 3, name: '区县' },
      ],
      tabVal: 1,
      provinceVal: 1,
      cityVal: null,
      countyVal: null,
      cityList: {},
      countryList: {},
    };
  },

  mounted() {
    let self = this;
    this.$nextTick(() => {
      document.addEventListener('click', function (e) {
        let codeBox = document.getElementById("postCode");
        if (codeBox && !codeBox.contains(e.target) && self.millState) {
          self.$emit('codeStateChange', false);
        };
      })
    });
  },

  methods: {
    // 省市区切换监测
    tabChange(id) {
      this.tabVal = id;
    },
    // 省市区数据监测
    codeChange(val) {
      let self = this;
      self.provinceVal = val.id;
      if (!_validate.checkListEmpty(val.children)) {
        if (val.level == 1) {
          self.cityList = _tools.pinyinSort(val.children, 'name');
          self.tabVal = 2;
        } else if (val.level == 2) {
          self.countryList = _tools.pinyinSort(val.children, 'name');
          self.tabVal = 3;
        }
      } else {
        this.$emit('codeChange', val.postcode);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.post-box {
  position: absolute;
  width: 500px;
  height: 260px;
  overflow: hidden;
  border: 1px solid #DCDFE6;
  background: #fff;
  border-radius: 2px;
  top: 35px;
  right: 0;
  z-index: 9;

  &.left {
    left: -219px;
  }
  .code-box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .tab-box {
      width: 100%;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-family: SourceHanSansSC-Normal, SourceHanSansSC;
      font-weight: 400;
      color: #666666;

      .tab-item {
        border-bottom: 1px solid #DCDFE6;
        flex: 1;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
      }

      .tab-item:nth-child(2) {
        border-left: 1px solid #DCDFE6;
        border-right: 1px solid #DCDFE6;
      }

      .active {
        border-bottom: none !important;
        color: #ff7200;
      }
    }

    .code-list {
      display: flex;
      margin-top: 10px;

      .code-list-name {
        width: 70px;
        min-width: 70px;
        text-align: center;
        font-size: 14px;
        font-family: SourceHanSansSC-Normal, SourceHanSansSC;
        font-weight: 400;
      }

      .code-list-box {
        display: flex;
        flex-wrap: wrap;

        .clb-item {
          padding: 0 15px 5px 0;
          font-size: 13px;
          font-family: SourceHanSansSC-Normal, SourceHanSansSC;
          font-weight: 400;
          cursor: pointer;
        }
      }
    }
  }
}
</style>